/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    variants: {
        plpH3: {
            color: 'black',
            fontSize: 'sm',
            fontWeight: 'normal'
        },
        plpH2: {
            lineHeight: 'base'
        },
        pdpH1: {
            color: 'black',
            fontSize: 'md'
        },
        productSetHeading: {
            color: 'black',
            fontSize: ['sm', null, 'md'],
            textTransform: 'uppercase'
        },
        accordionPdp: {
            fontWeight: 'bold',
            fontSize: 'xs',
            textTransform: 'uppercase'
        },
        smartSearchHeading: {
            fontSize: ['sm', null, 'md'],
            fontWeight: 'bold',
            textTransform: 'uppercase',
            mb: 2
        }
    }
}
